/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_TitleInputs */

const cs_billing_plan_title = /** @type {(inputs: Billing_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif předplatného`)
};

const en_billing_plan_title = /** @type {(inputs: Billing_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription plan`)
};

/**
* | output |
* | --- |
* | "Subscription plan" |
*
* @param {Billing_Plan_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_title = /** @type {((inputs?: Billing_Plan_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_title(inputs)
	return cs_billing_plan_title(inputs)
});